import { render, staticRenderFns } from "./DataRender.vue?vue&type=template&id=23a987e6"
import script from "./DataRender.vue?vue&type=script&lang=ts"
export * from "./DataRender.vue?vue&type=script&lang=ts"
import style0 from "./DataRender.vue?vue&type=style&index=0&id=23a987e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports